import React from 'react';

import { Connect, FormSection, Hero } from '../../components/Contact';

type Props = {};

const ContactUs = (_props: Props) => {
  return (
    <div>
      <Hero />
      <FormSection />
      <Connect />
    </div>
  );
};

export default ContactUs;
